import { Button, ButtonText } from "@repo/components/src/ui/button";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
} from "@repo/components/src/ui/checkbox";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
} from "@repo/components/src/ui/form-control";
import { Link } from "expo-router";
import { AlertCircleIcon, CheckIcon } from "lucide-react-native";
import {
  Control,
  Controller,
  FieldPathByValue,
  FieldValues,
} from "react-hook-form";
import { PRIVACY_URL, TERMS_URL } from "./links";

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPathByValue<T, boolean>;
  disabled?: boolean;
};

/**
 * The required consent of the sign-up: the terms, the privacy policy, WhatsApp
 * notices and sharing hashed data with Meta and TikTok to measure ads, in one
 * checkbox, as the backend records it (`acceptedTerms`).
 */
function TermsCheckbox<T extends FieldValues>({
  control,
  name,
  disabled,
}: Props<T>) {
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({
        field: { onChange, value, name: fieldName, disabled: fieldDisabled },
        fieldState: { error },
      }) => (
        <FormControl isInvalid={!!error} isDisabled={fieldDisabled}>
          <Checkbox
            value={fieldName}
            isChecked={value === true}
            onChange={onChange}
            className="items-start"
          >
            <CheckboxIndicator className="mt-0.5">
              <CheckboxIcon as={CheckIcon} />
            </CheckboxIndicator>
            <CheckboxLabel className="flex-1">
              Acepto los{" "}
              <Link href={TERMS_URL} target="_blank" asChild>
                <Button
                  action="brand"
                  variant="link"
                  size="sm"
                  className="inline h-fit"
                >
                  <ButtonText>Términos y condiciones</ButtonText>
                </Button>
              </Link>{" "}
              y la{" "}
              <Link href={PRIVACY_URL} target="_blank" asChild>
                <Button
                  action="brand"
                  variant="link"
                  size="sm"
                  className="inline h-fit"
                >
                  <ButtonText>Política de privacidad</ButtonText>
                </Button>
              </Link>
              .
            </CheckboxLabel>
          </Checkbox>
          <FormControlError>
            <FormControlErrorIcon as={AlertCircleIcon} className="mr-1" />
            <FormControlErrorText>{error?.message}</FormControlErrorText>
          </FormControlError>
        </FormControl>
      )}
    />
  );
}

export default TermsCheckbox;
